<template>
  <button id="menu-button" type="button" @click="onClick">
    <svgicon v-if="open" icon="glyph/32/close" width="32" height="32"></svgicon>
    <svgicon v-else icon="glyph/32/bars" width="32" height="32"></svgicon>
    <div v-if="message" class="messageicon">
      <span>
        <svgicon icon="glyph/12/email" width="12" height="12"></svgicon>
      </span>
    </div>
    <span class="sr-only">{{ open ? "Close Menu" : "Open Menu" }}</span>
  </button>
</template>

<script>
import Legacy from '@/core/legacy'
export default {
  name: "MenuButtonComponent",
  data() {
    return {
      showMenuState: false 
    }
  },
  computed: {
    open() {
      return this.showMenuState
    },
    message() {
      const messageExists = $("#menu_messagecenter .menuitem__text").html() ? $("#menu_messagecenter .menuitem__text").html().replace(/[^0-9]/g,'') : ""

      return messageExists > 0 
    }
  },
  methods: {
    onClick() {
      this.showMenuState = !this.showMenuState
      Legacy.showMenu( this.showMenuState )
    }
  }
}
</script>

<style lang="less">
@import "../assets/css/abstract/variables.less";

  .messageicon {
    position: absolute;
    top: -10%;
    left: 50%;
    width: 24px;
    height: 24px;     
    background-color: @tertiary-color;
    border-radius: 31px;          
    border: solid 1px rgba(192, 192, 192, 0.5);

    .svg-icon {
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -6px !important;
      margin-left: -6px !important;  

      & * {
        fill: @header-text-color;
      }
    }
  }

</style>
